import type { FC } from 'react';

import { cn } from '@/lib/utils';

import {
    ContentText,
    type ContentTextProps,
} from '@/components/molecules/ContentText';
import RegistrationForm from '@/components/organisms/RegistrationForm';

export type FormConfigType = {
    campaignName?: string;
    text?: string;
};

export interface RegisterFormContentProps {
    contentTextConfig: ContentTextProps;
    formConfig: FormConfigType[];
}

const RegisterFormContent: FC<RegisterFormContentProps> = ({
    contentTextConfig,
    formConfig,
}) => (
    <div className="flex w-full max-w-[22rem] flex-col lg:max-w-[556px]">
        <ContentText
            {...contentTextConfig}
            className={cn(
                'text-center md:text-left',
                contentTextConfig.className,
            )}
        />

        <RegistrationForm
            formConfig={formConfig}
            formName="KampaniaRejestracja"
            className="mt-3 md:mt-5"
        />
    </div>
);

export default RegisterFormContent;
